// componente che contiene tutte le "routes", ovvero le pagine verso cui indirizza un determinato path
// definito internamente alla webapp

import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './guards/auth.guard';
import { PersonalDataComponent } from '../view/pages/personalData/personaldata.component';
import { DashboardComponent } from '../view/pages/dashboard/dashboard.component';
import { RegisterComponent } from '../view/pages/users/register/register.component';
import { RegistriesTabComponent } from './registries.component';
import { CallStatusTabComponent } from './callStatusComplete';
import { AlarmTabComponent } from './alarm.component';
import { SettingsComponent } from '../view/pages/settings/settings.component';
import { MobileComponent } from '../view/pages/mobile/mobile.component';
import { SettingsTabComponent } from './settings.component';
import { MobileTabComponent } from './mobile';

const appRoutes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'calls', component: CallStatusTabComponent, canActivate: [AuthGuard] },
  { path: 'registries', component: RegistriesTabComponent, canActivate: [AuthGuard] },
  { path: 'emergencies', component: AlarmTabComponent, canActivate: [AuthGuard] },
  { path: 'register', component: RegisterComponent },
  { path: 'personal', component: PersonalDataComponent },
  { path: 'settings', component: SettingsTabComponent },
  { path: 'mobile', component: MobileTabComponent },

];

export const routing = RouterModule.forRoot(appRoutes, { enableTracing: true })

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
